import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import Frame from '..';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IFrame, IScaleInfo } from '../frame.interface';
import { AdjustGroupFrameInfo } from './adjusted-info';
import { IAdjustedElementsAndProps, IGroupFrameProperty } from './index.interface';
import { enumerateGroup } from '../../group-operation/enumerate';

export default class GroupFrame extends Frame implements IGroupFrameProperty {
    private adjustGroupFrameInfo: AdjustGroupFrameInfo;
    private groupModel: IGroupModel | ISmartArtModel;
    public constructor(model: IGroupModel | ISmartArtModel) {
        super(model);
        this.groupModel = model;
    }

    public getAdjustedElementsAndProps(
        childModels = this.groupModel.selectionService?.selectedElements
            .selectedArrayForType(SelectedEleMgrType.GROUP) ?? [],
        childModelsProps?: IFrame[],
    ): IAdjustedElementsAndProps[] {
        if (!this.adjustGroupFrameInfo) {
            this.adjustGroupFrameInfo = new AdjustGroupFrameInfo();
        }
        return this.adjustGroupFrameInfo.getAdjustedElementsAndProps(childModels, childModelsProps);
    }

    public clearTempInfosWithElement(element: IElementBaseModel) {
        enumerateGroup(element, (groupModel: IGroupModel) => {
            if (groupModel.groupChildFrameChangedByChildren) {
                groupModel.groupChildFrameChangedByChildren = null;
            }
        });
    }

    public getScaleRelativeToSlide(): IScaleInfo {
        const infosFromInner: Array<{scaleX: number, scaleY: number, rotate: number}> = [];
        infosFromInner.push({
            scaleX: this.groupModel.scaleX,
            scaleY: this.groupModel.scaleY,
            rotate: this.groupModel.props.style.rotate ?? 0,
        });
        enumerateGroup(this.groupModel, (groupModel: IGroupModel) => {
            infosFromInner.push({
                scaleX: groupModel.scaleX,
                scaleY: groupModel.scaleY,
                rotate: this.groupModel.props.style.rotate ?? 0,
            });
        });
        const infosFromOuter = infosFromInner.reverse();
        const scale = {
            scaleX: 1,
            scaleY: 1,
        };
        infosFromOuter.forEach((info) => {
            if (this.needChange(info.rotate)) {
                const temp = scale.scaleX;
                scale.scaleX = scale.scaleY;
                scale.scaleY = temp;
            }
            scale.scaleX *= info.scaleX;
            scale.scaleY *= info.scaleY;
        });
        return scale;
    }

    private needChange(rotate: number): boolean {
        return (rotate >= 45 && rotate < 135) || (rotate >= 225 && rotate < 315);
    }
}
